export default "__VITE_ASSET__BiODBQkv__"